import React, { useContext, useEffect, useState } from 'react';
import './cartao-secondCopyRequest-modal.css';
import { AuthContext } from '../../../contexts/AuthContext';
import { toast } from 'react-toastify';
import { AccountContext } from '../../../contexts/AccountContext';
import { BsCreditCard2Front, BsInfoCircleFill } from 'react-icons/bs';
import ReactModal from 'react-modal';
import { useCards } from '../../../hooks/useCards';

export const ModalSecondCopyRequest = ({ isOpen, onClose, card }) => {
  const [reason, setReason] = useState('');
  const [requestLoader, setRequestLoader] = useState(false);
  const { user } = useContext(AuthContext);
  const { getBalance, avaliableBalance } = useContext(AccountContext);
  const { requestCard, updateCard } = useCards();
  const address = user?.address?.length && user?.address[0];

  const requestValue = 30;
  const isBalanceSufficient = avaliableBalance >= requestValue;
  const isRequestDisabled = !isBalanceSufficient || requestLoader || !reason;

  useEffect(() => {
    getBalance();
  }, []);

  const handleReasonChange = (e) => {
    setReason(e.target.value);
  };

  const handleSubmit = async () => {
    if (!reason) {
      setError('Selecione um motivo para a solicitação *');
      return;
    }
    try {
      setRequestLoader(true);
      setError('');

      await updateCard({
        id: card.id,
        blocked: true,
        blockedReason: reason,
      });
      await requestCard({
        zipCode: address.zipCode,
        address: address.addressLine,
        addressNumber: address.addressLine2,
        addressComplement: address.complement,
        neighborhood: address.neighborhood,
        city: address.cityName,
        state: address.state,
        isDependent: false,
        isSecondCopy: true,
      });
      toast.success('Uma nova via do cartão foi solicitada com sucesso!');
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    } catch (error) {
      toast.error('Erro ao solicitar cartão');
    } finally {
      setRequestLoader(false);
    }
  };
  const reasonOptions = [
    { value: '', label: 'Selecione um motivo para a solicitação' },
    { value: 'CARTAO_PERDIDO', label: 'Perda do cartão' },
    { value: 'CARTAO_ROUBADO', label: 'Roubo ou furto' },
    { value: 'CARTAO_INVALIDO', label: 'Cartão danificado' },
  ];

  return (
    <ReactModal
      isOpen={isOpen}
      className={"change-modal"}
      overlayClassName={"overlay-change-password-modal"}
    >
      <div className="modal show d-block" tabIndex="-1">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content border-0 shadow">
            <div className="modal-header">
              <h5 className="modal-title d-flex align-items-center">
                <BsCreditCard2Front className="me-2 text-success" />
                Solicitar Segunda Via
              </h5>
              <button
                type="button"
                className="btn-close"
                onClick={onClose}
                aria-label="Close"
              ></button>
            </div>

            <div className="modal-body p-4">
              <div className="mb-4">
                <div className="d-flex align-items-center mb-3">
                  <div className="bg-light p-2 rounded-3 me-3">
                    <BsCreditCard2Front size={24} className="text-success" />
                  </div>
                  <div>
                    <p className="mb-0">Cartão final <strong>{card?.lastFour}</strong></p>
                  </div>
                </div>

                <div className="alert alert-warning d-flex p-3">
                  <BsInfoCircleFill className="me-2 flex-shrink-0 mt-1" />
                  <div className="small">
                    Será cobrado <strong>{requestValue.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</strong> pela emissão da segunda via.
                  </div>
                </div>
              </div>

              <div className="mb-3">
                <label htmlFor="requestReason" className="form-label">
                  Motivo da solicitação
                </label>
                <select
                  id="requestReason"
                  className="form-select"
                  value={reason}
                  onChange={handleReasonChange}
                >
                  {reasonOptions.map(option => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className="modal-footer bg-light">
              <button
                type="button"
                className="btn btn-outline-secondary"
                onClick={onClose}
              >
                Cancelar
              </button>
              <button
                type="button"
                className="btn btn-success"
                onClick={handleSubmit}
                disabled={isRequestDisabled}
              >
                Solicitar segunda via
              </button>
            </div>
          </div>
        </div>
      </div>
    </ReactModal>
  );
};
